import { render } from "./menu-dropdown.vue?vue&type=template&id=7b187276&lang=pug"
import script from "./menu-dropdown.vue?vue&type=script&lang=js"
export * from "./menu-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__